module.exports = __webpack_public_path__ + "img/perzeption-arrow.57b5e104.svg";